import React, { useState } from 'react'
import OfficeImg from "../assets/office2.png"
import { api } from '../app/Api/ApiSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

const SuggestedBranchCard = ({ b }) => {
    const [isLoading,setIsLoading] = useState(false)
    const navigate = useNavigate()

     const { organization } = useParams()

      const handleAdd = async(id)=>{
        try {
            setIsLoading(true)
            const response = await api.post(`/${organization}/branches/requests/sent`,{id})
            if(response){
                setIsLoading(false)
                toast.success("branch request sent")
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response.data.message)
        }finally{
            setIsLoading(false)
        }
    }
    return (
        <div className="branch-info">
            <img src={b.logo ? b.logo : OfficeImg} alt="" />
            <div className="branch-desc" >
                <h3 onClick={()=>navigate(`/${b.name}`)}>{b.name}</h3>
                <p>
                    {b.description
                        ? b.description.length > 50
                            ? `${b.description.substring(0, 50)}...`
                            : b.description
                        : "No description available"}
                </p>

                <button className="branch-action-card-btn" onClick={() => handleAdd(b._id)}>{!isLoading?"Add Parent":"..."}</button>
            </div>
        </div>
    )
}

export default SuggestedBranchCard